import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchPosts } from '../../store/slices/post.slice'
import { ArticleTag } from '../HomePage/ArticleTag'
import { articelsHomePageImages } from '../../services/images.service'
import { formatHebrewDate } from '../../services/util.service'
import { GreyBorderBottom } from '../ui/elements'

export function RelatedPost({ anime }) {
  const dispatch = useDispatch()

  // ✅ וודא שהשם נכון לפי ה-Redux DevTools
  const {
    posts = [],
    isLoading,
    error,
  } = useSelector((state) => state.postModule || {})

  useEffect(() => {
    if (!posts.length) {
      dispatch(fetchPosts())
    }
  }, [dispatch, posts.length])

  // ✅ טיפול במקרה שבו `linkedAnime` הוא URL וצריך להוציא את ה-mal_id
  const animeId = anime.mal_id ? anime.mal_id.toString() : ''

  const relatedPosts = useMemo(() => {
    return posts.filter((post) => {
      if (!post.linkedAnime) return false
  
      let linkedAnimeId;
      if (post.linkedAnime.includes('/anime/')) {
        // שליפת ה-mal_id מתוך URL שכולל /anime/
        linkedAnimeId = post.linkedAnime.split('/anime/')[1]?.split('/')[0]
      } else {
        // נניח שהפורמט הוא mal_id/Title
        linkedAnimeId = post.linkedAnime.split('/')[0]
      }
  
      return linkedAnimeId === animeId || post.linkedAnime === anime.url
    })
  }, [posts, anime.url, animeId])
  

  return (
    <section>
      <div className="">
        <h5>כתבות קשורות</h5>
 <GreyBorderBottom className="w-full" />
      </div>
      {isLoading && <p>🔄 טוען כתבות קשורות...</p>}
      {error && <p className="text-red-500">❌ שגיאה: {error}</p>}

      {relatedPosts.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {relatedPosts.map((post) => (
            <div key={post._id} className="mt-5 relative">
              <Link to={`/post/${post._id}`}>
                {post.imageUrl && (
                  <img
                    src={post.imageUrl}
                    alt={post.title}
                    className="w-full h-[220px] lg: object-cover mb-4"
                  />
                )}
                <div className="absolute -translate-y-[90%] right-4">
                  <ArticleTag tags={post.tags} />
                </div>

                <h3 className="text-xl mt-8 max-w-[320px]">{post.title}</h3>
                <h5 className="text-muted text-xs">
                  עלה ב {formatHebrewDate(post.createdAt)}, ע"י{' '}
                  <Link to={`/user/${post.author?.userId}`}><span className='hover:underline'>{post.author?.nickname}</span></Link>

                </h5>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 mt-2">❌ אין כרגע כתבות קשורות.</p>
      )}
    </section>
  )
}
